<template>
  <router-view />
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'CustomLayout',
  computed: mapState(['settings']),
  data: function () {
    return {};
  },
};
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
